import * as React from "react"
import { NavSidebarContext } from "src/frontend/components/Shared/NavSidebar/NavSidebarContext"

/**
 * Access shared state and actions for the NavSidebar.
 */
export function useNavSidebarContext() {
  return React.useContext(NavSidebarContext)
}
